import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    fontSize: theme.size.sm,
    color: theme.palette.primary.main,
    margin: '0',

    '&:hover .delete-container': {
      display: 'flex'
    }
  },

  icon: {
    marginRight: '0.5rem'
  },

  deleteContainer: {
    display: 'none',
    alignItems: 'center',

    [theme.breakpoints.down('md')]: {
      display: 'flex'
    }
  },

  delete: {
    marginLeft: '0.5rem',
    color: theme.palette.textAlt,
    cursor: 'pointer'
  },

  audio: {
    height: 30,
    [theme.breakpoints.down('sm')]: {
      width: 180
    }
  }
}))

export default useStyles
